export default __webpack_public_path__ + "static/media/maze.cfdd8bf8.svg";